import React, { useState, useEffect } from "react";

import Navbar from "../../components/navbar/Navbar";
import CountryTabs from "./CountryTabs";
import TopUniversity from "./TopUniversity";
import VisaRequirement from "./VisaRequirement";
import LifeStyle from "./LifeStyle";
import Faq from "./Faq";
import ScholarShip from "./ScholarShip";
import Footer from "../../components/footer/footer";
import WOW from "wowjs";
import { useLocation } from "react-router-dom";
import "./css/newexplorestyle.css";
import CountryAboutUsSection from "./CountryAboutUsSection";
import StudyCostTable from "./StudyCostTable";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";

export default function Blog() {
  const { state } = useLocation();
  const [selectedTab, setSelectedTab] = useState("GERMANY");
  const [expectedCountry, setExpectedCountry] = useState(null);

  useEffect(() => {
    new WOW.WOW({
      animateClass: "animated",
      offset: 160,
      callback: function (box) {},
    }).init();
  }, []);

  useEffect(() => {
    console.log(state, "state");
    if (state != null && state != undefined) {
      setExpectedCountry(state);
    }
  }, [state]);

  const fetchSelectedTab = (tabSelected) => {
    setSelectedTab(tabSelected);
  };

  return (
    <div className="blog_main_container">
      <div className="nav_container">
        <Navbar fromPage="Countries" />
      </div>

      <CountryTabs
        fetchSelectedTab={fetchSelectedTab}
        expectedCountry={expectedCountry}
      />
      <CountryAboutUsSection selectedTab={selectedTab} />
      <TopUniversity selectedTab={selectedTab} />
      <StudyCostTable selectedTab={selectedTab} />
      {/* // <StudyCost selectedTab={selectedTab} /> */}
      <VisaRequirement selectedTab={selectedTab} />
      <ScholarShip selectedTab={selectedTab} />
      <LifeStyle selectedTab={selectedTab} />
      <InterestedSectionMain />
      <Faq selectedTab={selectedTab} />

      <Footer />
    </div>
  );
}
